import React from 'react';
import MailComponent from '../components/pure/mailComponent';

const Mail = () => {
    return (
        <div className='container mx-auto h-screen flex'>
            <MailComponent />
        </div>
    );
}

export default Mail;
